import axios from "axios"
import mapDatatoAsociar from "common/mappers/mapDatatoAsociar"
import mapDocumentoToPost from "common/mappers/mapDocumentoToPost"
import { queryFixer } from "common/utils/utils"

const PresupuestoService = {
  post(
    documento: $TSMigrationFixMe,
    sinValorar: $TSMigrationFixMe,
    formaPagoIban: $TSMigrationFixMe,
    isLibrador: $TSMigrationFixMe
  ) {
    const postPresupuesto = mapDocumentoToPost(
      documento,
      sinValorar,
      false,
      formaPagoIban,
      // @ts-expect-error TS(2345): Argument of type 'false' is not assignable to para...
      false,
      isLibrador
    )
    return axios.post("/Presupuesto", postPresupuesto).then(async (res) => {
      const { data: presupuestoCreatedBody } = await axios.get(
        `/Presupuesto/${res.data}`
      )
      const dataMapped = mapDatatoAsociar(presupuestoCreatedBody)
      sessionStorage.setItem("nextDocAsc", JSON.stringify(dataMapped))
    })
  },
  getPresupuestosByMsgEncrypted({
    msgEncrypted,
    queryState,
  }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Presupuesto/by-filters-encrypted?MsgEncrypted=${msgEncrypted}`,
      queryState
    )
    return axios.get(query)
  },
  getArchivosAdjuntosById(id: $TSMigrationFixMe) {
    return axios.get(`/Presupuesto/${id}/ficheros-adjuntos`)
  },

  getDocumentosAsociadosById(id: $TSMigrationFixMe) {
    return axios.get(`/Presupuesto/${id}/documentos-asociados`)
  },

  addNewArchivoAdjunto(
    presupuestoID: $TSMigrationFixMe,
    file: $TSMigrationFixMe
  ) {
    return axios.post(`/Presupuesto/${presupuestoID}/add-fichero-adjunto`, file)
  },

  deleteArchivoAdjunto(
    presupuestoID: $TSMigrationFixMe,
    fileID: $TSMigrationFixMe
  ) {
    return axios.delete(`/Presupuesto/${presupuestoID}/fichero/${fileID}`)
  },

  getById(id: $TSMigrationFixMe) {
    return axios.get(`/Presupuesto/${id}`)
  },

  archivosGetById(id: $TSMigrationFixMe) {
    return axios.get(`/Presupuesto/${id}/ficheros-adjuntos`)
  },

  getPdfById(id: $TSMigrationFixMe) {
    return axios.get(`/Presupuesto/${id}/pdf`, {
      responseType: "blob",
    })
  },

  getPresupuestosWithSameLibradoLibrador({
    libradoId,
    libradorId,
    ...filters
  }: $TSMigrationFixMe) {
    return axios.get("/Presupuesto/by-filters", {
      params: {
        ...filters,
        libradoId,
        libradorId,
      },
    })
  },

  getLastAvailableNumero(serie = "F") {
    return axios.get(`/Presupuesto/last-available-numero/${serie}`)
  },

  getPresupuestosEnviados({ libradorId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Presupuesto/by-filters?libradorId=${libradorId}`,
      queryState
    )
    return axios.get(query)
  },

  getPresupuestosRecibidos({ libradoId, queryState }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Presupuesto/by-filters?libradoId=${libradoId}`,
      queryState
    )
    return axios.get(query)
  },

  getPresupuestoByMsgEncrypted({ msgEncrypted }: $TSMigrationFixMe) {
    const query = queryFixer(
      `/Presupuesto/by-filters-encrypted?MsgEncrypted=${msgEncrypted}`
    )
    return axios.get(query)
  },
  changeEstado({
    documentoId,
    estadoRevisionDocumento,
    motivo,
  }: $TSMigrationFixMe) {
    return axios.put("/Presupuesto/change-estado", {
      documentoId,
      estadoRevisionDocumento,
      motivo: motivo?.length ? motivo : null,
    })
  },

  changeMultipleEstados({
    documentosId = [],
    estadoRevisionDocumento,
    motivo,
  }: $TSMigrationFixMe) {
    return axios.put("/Presupuesto/bulk-change-estado", {
      documentosId,
      estadoRevisionDocumento,
      motivo: motivo?.length ? motivo : null,
    })
  },
  getDocumentosPendientesValidar(queryParam: $TSMigrationFixMe) {
    return axios.get(`/Presupuesto/pendientes-firmar${queryParam}`)
  },
  getDocumentoPendienteValidacion(id: $TSMigrationFixMe) {
    return axios.get(`/Presupuesto/${id}/validacion`)
  },
  validateDocumentoPendiente(id: $TSMigrationFixMe, data: $TSMigrationFixMe) {
    return axios.post(`/Presupuesto/${id}/aprobacion`, data)
  },
}

export default PresupuestoService
